import type { Trip } from 'contracts/tracking-v2/trips';
import { Formatter } from 'utils';
import {
  getInvoiceOrigin,
  getInvoiceDestination,
} from 'pages/tracking-v2/utils/invoice-utils';

type Invoice = Trip['invoices'][number];
type InvoiceItem = Invoice['items'][number];

export const getInvoiceInfo = (invoice: Invoice) => {
  return {
    emissionDate: Formatter.dateFull(invoice.infnfeIdeDhemi),
    deadline: Formatter.dateFull(invoice.deadlineDate as string),
    value: Formatter.currency(invoice.totalIcmstotVnf),
    origin: getInvoiceOrigin(invoice).asCityAndUfText(),
    destination: getInvoiceDestination(invoice).asCityAndUfText(),
    companyTradeName: invoice?.company?.tradeName || '---',
  };
};

export const getInvoiceItemInfo = (item: InvoiceItem) => {
  return {
    productCode: item.prodCprod,
    productDescription: item.prodXprod,
    batch: item.rastroNlote || '---',
    batchQuantity: item.rastroQlote || '---',
    orderNumber: item.prodXped || '---',
    quantity: [item.prodQcom, item.prodUcom].join(' '),
    unitValue: getItemUnitValue(item),
    totalValue: Formatter.currency(item.prodVprod),
  };
};

const getItemUnitValue = (item: InvoiceItem) => {
  const { prodVuncom } = item;
  return prodVuncom ? Formatter.currency(prodVuncom) : '---';
};